module.exports = __webpack_public_path__ + "static/media/thumbnail_mellow.71a065a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coverpageThemeThumbnails/thumbnail_mellow.jpg
// module id = 1326
// module chunks = 17